/**
 * @generated SignedSource<<12a6edd7616d03a0cca930e8727755ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BaseData_component$data = {
  readonly chart: {
    readonly " $fragmentSpreads": FragmentRefs<"BaseDataChart_chart">;
  } | null | undefined;
  readonly entries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value?: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"ItemListEntry_component">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly equity: {
    readonly " $fragmentSpreads": FragmentRefs<"BaseDataEquity_content">;
  } | null | undefined;
  readonly files: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"FileLink_fileLink">;
  } | null | undefined> | null | undefined;
  readonly header: string | null | undefined;
  readonly " $fragmentType": "BaseData_component";
};
export type BaseData_component$key = {
  readonly " $data"?: BaseData_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"BaseData_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesAdmission"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BaseData_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "ComponentConnection",
      "kind": "LinkedField",
      "name": "entries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    }
                  ],
                  "type": "ItemListEntry",
                  "abstractKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ItemListEntry_component"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "entries(first:1000)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BaseDataEquity",
      "kind": "LinkedField",
      "name": "equity",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BaseDataEquity_content"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "salesAdmission",
          "variableName": "salesAdmission"
        }
      ],
      "concreteType": "FileLink",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FileLink_fileLink"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BaseDataChart",
      "kind": "LinkedField",
      "name": "chart",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BaseDataChart_chart"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BaseData",
  "abstractKey": null
};

(node as any).hash = "9fb32210c5e10971a0a5bdbdeece778d";

export default node;
